import { useResizeObserver } from '@vueuse/core'

import type { Ref } from 'vue'

const MAX_VISIBLE_LINES = 2

interface DisciplineSubstituteTutorsReturn {
  listRef: Ref<HTMLElement | null>
  refIsOverflowing: Ref<boolean>
  refIsExpanded: Ref<boolean>
  toggleExpanded: () => void
}

/** The substitute list folds to two lines; the chevron appears only when the names do not fit. */
export const useDisciplineSubstituteTutors = (): DisciplineSubstituteTutorsReturn => {
  const listRef = ref<HTMLElement | null>(null)
  const refIsOverflowing = ref(false)
  const refIsExpanded = ref(false)

  const checkOverflow = (): void => {
    const el = listRef.value
    const firstChild = el?.children[0] as HTMLElement | undefined
    if (!el || !firstChild) return

    const gap = parseFloat(getComputedStyle(el).rowGap) || 0
    const maxVisibleHeight = firstChild.offsetHeight * MAX_VISIBLE_LINES + gap * (MAX_VISIBLE_LINES - 1)
    refIsOverflowing.value = el.scrollHeight > maxVisibleHeight
  }

  const toggleExpanded = (): void => {
    refIsExpanded.value = !refIsExpanded.value
    if (!refIsExpanded.value) void nextTick(checkOverflow)
  }

  useResizeObserver(listRef, checkOverflow)

  onMounted(() => {
    void nextTick(checkOverflow)
  })

  return {
    listRef,
    refIsOverflowing,
    refIsExpanded,
    toggleExpanded,
  }
}
